import { createApi } from '@reduxjs/toolkit/query/react'

import { ListasSeleccion } from '../interfaces/ListasSeleccion'

import { baseQuery } from '@/core/api/baseQuery'
import { GenericResponseOData } from '@/core/api/interfaces/GenericResponseOData'
import { monedaListaSeleccion, monedaListaSeleccionById } from '@/modules/ReservasTemp/constants/queryListaSeleccion'

export const listasSeleccionApi = createApi({
  reducerPath: 'listasSeleccionApi',
  baseQuery,
  endpoints: (builder) => ({
    getNivelCodigoConfirmacionValue: builder.query<
      GenericResponseOData<ListasSeleccion[]>,
      number
    >({
      query: (nivelCodigoConfirmacionId: number) => ({
        url: `/ListasSeleccion?$filter=ListaSeleccionId in (${nivelCodigoConfirmacionId})&$select=ListaSeleccionId,Nombre,Valor`,
        method: 'GET',
      }),
    }),
    getListaMoneda: builder.query<
      GenericResponseOData<ListasSeleccion[]>,
      void
    >({
      query: () => ({
        url: `/ListasSeleccion?${monedaListaSeleccion}`,
        method: 'GET',
      }),
    }),
    getListaMonedaById: builder.query<
      GenericResponseOData<ListasSeleccion[]>,
      number
    >({
      query: (listaSeleccionId: number) => ({
        url: `/ListasSeleccion?${monedaListaSeleccionById.replace('{ID}', listaSeleccionId.toString())}`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useLazyGetNivelCodigoConfirmacionValueQuery,
  useLazyGetListaMonedaQuery,
  useLazyGetListaMonedaByIdQuery,
} = listasSeleccionApi
